import plugin from 'grapesjs-blocks-basic'
import { footerplugin } from './footerPlugin'

import 'grapesjs/dist/css/grapes.min.css'

const GrapesjsConfigFoot = (
  data,
  projectId = null,
  notPublished,
  thmId,
  assets,
  envData,
  authDetails,
  isLocalEnvironment,
) => {
  const navs = data.themeFooters
  let filteredTheme
  filteredTheme = data.themes.filter((f) => f.themeId === thmId)

  const filteredFooters = navs.filter((f) => f.themeId === thmId)

  const webProject = data.projects.filter((f) => f.websiteProjectId === projectId)

  return {
    container: '#gjs',
    fromElement: true,
    height: '100%',
    width: 'auto',
    allowScripts: true,
    showDevices: false,
    avoidInlineStyle: true,
    forceClass: false,
    blockManager: {
      appendTo: '#blocks',
      open: false,
    },
    mediaCondition: 'max-width',
    deviceManager: {
      devices: [
        {
          name: 'Desktop',
          width: '', // default size
          widthMedia: '', // this value will be used in CSS @media
        },
        {
          name: 'Tablet',
          width: '768px', // this value will be used on canvas width
          widthMedia: '992px', // this value will be used in CSS @media
        },
        {
          name: 'Mobile',
          width: '375px', // this value will be used on canvas width
          widthMedia: '575px', // this value will be used in CSS @media
        },
      ],
    },
    layerManager: {
      appendTo: '.layers-container',
    },
    panels: {
      defaults: [
        // ...
        {
          id: 'panel-switcher',
          el: '.panel__switcher',
          buttons: [
            {
              id: 'undo',
              className: 'undo',
              command: 'core:undo',
              attributes: { title: 'Undo (CTRL/CMD + Z)' },
            },
            {
              id: 'redo',
              className: 'redo',
              command: 'core:redo',
              attributes: { title: 'Redo (CTRL/CMD + SHIFT + Z)' },
            },
            {
              id: 'clean-all',
              className: 'trash',
              command: 'core:canvas-clear',
              attributes: { title: 'Empty canvas' },
            },
            {
              id: 'images',
              className: 'image',
              command: 'open-assset-manager',
              attributes: { title: 'Image Manager' },
            },
            {
              id: 'preview',
              className: 'preview',
              command: 'preview',
              attributes: { title: 'Preview' },
            },
          ],
        },
        {
          id: 'panel-switcher1',
          el: '.views-actions',
          buttons: [
            {
              id: 'deviceXl',
              className: 'screenWindow',
              command: 'set-device-xl',
              attributes: { title: 'Desktop' },
            },
            {
              id: 'deviceSm',
              className: 'tabWindow',
              command: 'set-device-sm',
              attributes: { title: 'Tablet' },
            },
            {
              id: 'deviceXs',
              className: 'mobilewindow',
              command: 'set-device-xs',
              attributes: { title: 'Mobile' },
            },
          ],
        },
      ],
    },
    domComponents: {
      storeWrapper: 1,
      wrapper: {
        stylable: [
          'background',
          'background-color',
          'background-image',
          'background-repeat',
          'background-attachment',
          'background-position',
          'background-size',
          'font-family',
          'font-size',
          'color',
          'width',
          'height',
          'max-width',
          'min-height',
          'margin',
          'margin-top',
          'margin-right',
          'margin-bottom',
          'margin-left',
          'padding',
          'padding-top',
          'padding-right',
          'padding-bottom',
          'padding-left',
        ],
      },
    },
    assetManager: {
      assets: assets,
      upload: `${isLocalEnvironment}/upload?endPoint=image`,
      uploadName: 'file',
      headers: {
        tokenSource: 'passport',
        Authorization: `Bearer ${authDetails.authentication.tokenObject}`,
      },
      credentials: 'include',
      multiUpload: false,
      modalTitle: 'Image Manager',
    },
    plugins: [footerplugin, plugin],
    pluginsOpts: {
      ...data,
      themeId: filteredTheme[0].themeId,
      footers: filteredFooters,
      notPublished,
      thmId,
    },
    colorPicker: { appendTo: 'parent', offset: { top: 26, left: -180 } },
    selectorManager: {
      appendTo: '#traits-container',
      componentFirst: true,
    },
    traitManager: {
      appendTo: '#traits-container',
      defaults: {},
    },
    styleManager: {
      appendTo: '.styles-container',
      sectors: [
        {
          name: 'General',
          open: false,
          buildProps: ['display', 'float', 'position', 'top', 'right', 'left', 'bottom'],
        },
        {
          name: 'Flex',
          open: false,
          buildProps: [
            'flex-direction',
            'flex-wrap',
            'justify-content',
            'align-items',
            'align-content',
            'order',
            'flex-basis',
            'flex-grow',
            'flex-shrink',
            'align-self',
          ],
        },
        {
          name: 'Dimension',
          open: false,
          buildProps: ['width', 'height', 'max-width', 'min-height', 'margin', 'padding'],
        },
        {
          name: 'Typography',
          open: false,
          buildProps: [
            'font-family',
            'font-size',
            'font-weight',
            'letter-spacing',
            'color',
            'line-height',
            'text-align',
            'text-shadow',
          ],
        },
        {
          name: 'Decorations',
          open: false,
          buildProps: ['background-color', 'border-radius', 'border', 'box-shadow', 'background'],
        },
        {
          name: 'Extra',
          open: false,
          buildProps: ['opacity', 'transition', 'transform'],
        },
      ],
    },
    storageManager: {
      id: 'gjs-', // Prefix identifier that will be used on parameters
      type: 'local', // Type of the storage
      autosave: true, // Store data automatically
      autoload: false, // Autoload stored data on init
      stepsBeforeSave: 1, // If autosave enabled, indicates how many changes are necessary before store method is triggered
    },
    canvas: {
      styles: [...JSON.parse(filteredTheme[0].themeCSS)],
      scripts: [...JSON.parse(filteredTheme[0].themeJS)],
    },
    pageManager: {
      pages: [
        {
          id: 'my-first-page',
          styles: '',
          component:
            webProject[0].websiteProjectFooter !== null ? webProject[0].websiteProjectFooter : '',
        },
      ],
    },
  }
}

export default GrapesjsConfigFoot
